"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toJSON = exports.fromJSON = exports.parse = exports.evaluate = exports.compact = exports.mapProperty = exports.map = exports.negate = exports.render = exports.properties = exports.atom = exports.or = exports.and = void 0;
var Grammar_1 = require("./Formula/Grammar");
var Util_1 = require("./Util");
function and() {
    var subs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        subs[_i] = arguments[_i];
    }
    return { kind: 'and', subs: subs };
}
exports.and = and;
function or() {
    var subs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        subs[_i] = arguments[_i];
    }
    return { kind: 'or', subs: subs };
}
exports.or = or;
function atom(p, v) {
    if (v === void 0) { v = true; }
    return { kind: 'atom', property: p, value: v };
}
exports.atom = atom;
function properties(f) {
    switch (f.kind) {
        case 'atom':
            return new Set([f.property]);
        default:
            return Util_1.union.apply(void 0, f.subs.map(properties));
    }
}
exports.properties = properties;
function render(f, term) {
    switch (f.kind) {
        case 'atom':
            var name_1 = term(f.property);
            return f.value ? name_1 : '¬' + name_1;
        case 'and':
            return '(' + f.subs.map(function (sf) { return render(sf, term); }).join(' ∧ ') + ')';
        case 'or':
            return '(' + f.subs.map(function (sf) { return render(sf, term); }).join(' ∨ ') + ')';
    }
}
exports.render = render;
function negate(formula) {
    switch (formula.kind) {
        case 'atom':
            return atom(formula.property, !formula.value);
        case 'and':
            return or.apply(void 0, formula.subs.map(negate));
        case 'or':
            return and.apply(void 0, formula.subs.map(negate));
    }
}
exports.negate = negate;
function map(func, formula) {
    switch (formula.kind) {
        case 'atom':
            return func(formula);
        default:
            return __assign(__assign({}, formula), { subs: formula.subs.map(function (sub) { return map(func, sub); }) });
    }
}
exports.map = map;
function mapProperty(func, formula) {
    function mapAtom(a) {
        return __assign(__assign({}, a), { property: func(a.property) });
    }
    return map(mapAtom, formula);
}
exports.mapProperty = mapProperty;
function compact(f) {
    return properties(f).has(undefined) ? undefined : f;
}
exports.compact = compact;
function evaluate(f, traits) {
    var result;
    switch (f.kind) {
        case 'atom':
            if (traits.has(f.property)) {
                return traits.get(f.property) === f.value;
            }
            return undefined;
        case 'and':
            result = true; // by default
            f.subs.forEach(function (sub) {
                if (result === false) {
                    return;
                }
                var sv = evaluate(sub, traits);
                if (sv === false) {
                    // definitely false
                    result = false;
                }
                else if (result && sv === undefined) {
                    // maybe false
                    result = undefined;
                }
            });
            return result;
        case 'or':
            result = false;
            f.subs.forEach(function (sub) {
                if (result === true) {
                    return;
                }
                var sv = evaluate(sub, traits);
                if (sv === true) {
                    // definitely true
                    result = true;
                }
                else if (result === false && sv === undefined) {
                    // maybe true
                    result = undefined;
                }
            });
            return result;
    }
}
exports.evaluate = evaluate;
function parse(q) {
    if (!q) {
        return;
    }
    var parsed;
    try {
        parsed = Grammar_1.parse(q);
    }
    catch (_a) {
        if (q && q.startsWith('(')) {
            return;
        }
        else {
            return parse('(' + q + ')');
        }
    }
    return fromJSON(parsed);
}
exports.parse = parse;
function fromJSON(json) {
    if (json.and) {
        return and.apply(void 0, json.and.map(fromJSON));
    }
    else if (json.or) {
        return or.apply(void 0, json.or.map(fromJSON));
    }
    else if (json.property) {
        return atom(json.property, json.value);
    }
    else {
        var property = Object.keys(json)[0];
        return atom(property, json[property]);
    }
}
exports.fromJSON = fromJSON;
function toJSON(f) {
    var _a;
    switch (f.kind) {
        case 'atom':
            return _a = {}, _a[f.property] = f.value, _a;
        case 'and':
            return { and: f.subs.map(toJSON) };
        case 'or':
            return { or: f.subs.map(toJSON) };
    }
}
exports.toJSON = toJSON;
